module.exports = __webpack_public_path__ + "img/add_btn_icon210.c1d5fb03.svg";